import ConfigService from '../index'
class CorporationService extends ConfigService {
    constructor(){
        super('filiais/api/v1/filiais/')
    }
}
export default CorporationService
